import React, { useState } from "react"
import isByteLength from "validator/lib/isByteLength"
import isEmpty from "validator/lib/isEmpty"
import { useDispatch } from "react-redux"
import jwtDecode from "jwt-decode"
import { useHistory } from "react-router-dom"
import { useTranslation } from "react-i18next"
import axios from "axios"

import {
  getSiteDomain,
  isInPosDevice,
  isInKioskMode,
  saveTokensInLocaleStorage
} from "utils"
import { setSystemSubdomain } from "@redux"
import { Button, TextField } from "components"
import { initApi, resetApi } from "services/api"
import { getServiceBaseUrl } from "services/api"
import classes from "./SignInWithPassword.module.scss"

const initialFormErrorsState = {
  username: "",
  password: "",
  url: ""
}

const SignInWithPassword = props => {
  const { form, setForm } = props

  const [t] = useTranslation()

  const history = useHistory()

  const dispatch = useDispatch()

  const [sending, setSending] = useState(false)
  const [formErrors, setFormErrors] = useState(initialFormErrorsState)

  const handleChange = (value, name) => {
    setForm(prev => ({
      ...prev, [name]: value
    }))
  }

  const validate = () => {
    const errors = { ...initialFormErrorsState }
    let result = true

    if (isEmpty(form.subdomain)) {
      errors.url = t("ساب_دامین_اجباری_است")
      result = false
    }

    if (isEmpty(form.username)) {
      errors.username = t("یوزرنیم_اجباری_است")
      result = false
    }

    if (isEmpty(form.password)) {
      errors.password = t("رمز_عبور_الزامی_است")
      result = false
    } else if (!isByteLength(form.password, { max: 20 })) {
      errors.password = t("رمز_عبور_باید_تا_20_کاراکتر_باشد")
      result = false
    }

    setFormErrors({ ...errors })

    return result
  }

  const checkUserRole = (accessToken) => {
    const { role } = jwtDecode(accessToken)

    if (role === "access") return true

    setFormErrors(prev => ({
      ...prev,
      password: t("اجازه_دسترسی_به_این_پنل_را_ندارین")
    }))

    setSending(false)

    return false
  }

  const handleSignin = async (e) => {
    e.preventDefault()

    if (!validate()) return

    setSending(true)

    let query = ""

    if (isInPosDevice()) {
      const random = String(Date.now())

      query = random ? `?random=${random}` : ""
    }

    const domain = getSiteDomain()

    const data = {
      domain,
      subdomain: form.subdomain
    }

    localStorage.setItem(
      "url",
      JSON.stringify(data)
    )

    const url =
      `${getServiceBaseUrl(
        domain,
        "auth",
        process.env.REACT_APP_API_AUTH_URL
      )}account/login/username${query}`

    try {
      const { data: response } =
        await axios.post(
          url
          ,
          {
            username: form.username,
            password: form.password
          },
          {
            headers: { "X-Service-Client-Name": form.subdomain }
          }
        )

      const tokens = {
        accessToken: response["X-Access-Token"],
        refreshToken: response["X-Refresh-Token"]
      }

      if (!checkUserRole(tokens.accessToken)) return

      resetApi()

      initApi(domain)

      dispatch(
        setSystemSubdomain(domain, form.subdomain)
      )

      saveTokensInLocaleStorage(
        tokens.accessToken,
        tokens.refreshToken
      )

      const pathname =
        isInKioskMode() ? "/kiosk-languages" : "/foods"

      history.push(
        pathname,
        { redirectFromSignin: true }
      )
    } catch (err) {
      console.log(err)

      setFormErrors(prev => ({
        ...prev,
        password: t("ورود_موفقیت_آمیز_نبود")
      }))

      setSending(false)
    }
  }

  return (
    <form
      className={classes["container"]}
      onSubmit={handleSignin}
    >
      <div className={classes["row"]}>
        <TextField
          label={t("ساب_دامین")}
          value={form.subdomain}
          onChange={(e) => handleChange(e.target.value, "subdomain")}
          error={formErrors.url}
          withoutSpace
          autoCapitalize="none"
          className={classes["input"]}
        />

        <TextField
          className={classes["input"]}
          label={t("یوزرنیم")}
          autoCapitalize="none"
          value={form.username}
          error={formErrors.username}
          onChange={e => handleChange(e.target.value, "username")}
          withoutSpace
        />
        <TextField
          isPassword
          autoCapitalize="none"
          type="password"
          className={classes["input"]}
          label={t("رمز_عبور")}
          value={form.password}
          onChange={(e) => handleChange(e.target.value, "password")}
          error={formErrors.password}
          withoutSpace
        />
      </div>

      <Button
        type="submit"
        className={classes["button"]}
        loading={sending}
      >
        {t("ورود")}
      </Button>
    </form>
  )
}

export default SignInWithPassword
